var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernApplicationDevelopmentServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 41.25H36.25",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35.5V19.5C17.5 19.0858 17.8358 18.75 18.25 18.75H41.75C42.1643 18.75 42.5 19.0858 42.5 19.5V35.5C42.5 35.9143 42.1643 36.25 41.75 36.25H18.25C17.8358 36.25 17.5 35.9143 17.5 35.5Z",
    stroke: "#DC2418",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernApplicationDevelopmentServices);
export default __webpack_public_path__ + "static/media/modernApplicationDevelopmentServices.bf9a4255554044450813f0e32a34ae40.svg";
export { ForwardRef as ReactComponent };